/**
 * Raw API functions for customer favorites.
 * No React, no hooks — pure async functions safe to use anywhere.
 */
import axiosObj from '@/store/axios';
import { getEitherCustIdFromLs } from '@/utils/useUserInfo';
import { ToggleFavoritePayload, ToggleFavoriteResponse } from '@/lib/schemas/favorites';

export const fetchFavorites = async (customerId: string): Promise<any[]> => {
  const response = await axiosObj.get(`/api/customer-favorites?customerId=${customerId}`);
  return response.data;
};

export const toggleFavorite = async (
  payload: ToggleFavoritePayload,
): Promise<ToggleFavoriteResponse> => {
  const { itemId, isFavorite, type, itemAdditionalData } = payload;
  const {
    productImage,
    price,
    comparePrice,
    model3dUrl,
    availability,
    productName,
    image,
    name,
    isPersonalizable,
  } = (itemAdditionalData ?? {}) as Record<string, any>;

  if (isFavorite) {
    await axiosObj.delete('/api/customer-favorites', {
      data: {
        customerId: getEitherCustIdFromLs(),
        itemId,
        type,
      },
    });
    return { itemId, isFavorite: false, type, itemAdditionalData };
  } else {
    await axiosObj.post('/api/customer-favorites', {
      customerId: getEitherCustIdFromLs(),
      itemId,
      type,
      price,
      comparePrice,
      model3dUrl,
      availability,
      isPersonalizable,
      image: productImage ?? image,
      name: productName ?? name,
    });
    return { itemId, isFavorite: true, type, itemAdditionalData };
  }
};
